import {inject, Injectable} from '@angular/core';
import {AppConfigService} from '../../services/config.service';
import {getBuildInfoText} from './build-info';

@Injectable({providedIn: 'root'})
export class VersionService {

    private readonly appConfigService = inject(AppConfigService);

    public getBuildInfoText(): string {
        return getBuildInfoText(this.appConfigService.appConfig);
    }

}
